var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6" }, [
        _c(
          "div",
          [
            _c(
              "form",
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modeSelection,
                          expression: "modeSelection"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "inlineRadioOptions",
                        id: "inlineRadio1",
                        value: "manual"
                      },
                      domProps: {
                        checked: _vm._q(_vm.modeSelection, "manual")
                      },
                      on: {
                        change: function($event) {
                          _vm.modeSelection = "manual"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "inlineRadio1" }
                      },
                      [_vm._v("Manual")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modeSelection,
                          expression: "modeSelection"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "inlineRadioOptions",
                        id: "inlineRadio2",
                        value: "list"
                      },
                      domProps: { checked: _vm._q(_vm.modeSelection, "list") },
                      on: {
                        change: function($event) {
                          _vm.modeSelection = "list"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "inlineRadio2" }
                      },
                      [_vm._v("List")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.modeSelection === "list"
                    ? _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.targetName,
                              expression: "targetName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { id: "target-list" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.targetName = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Select a target...")
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            Array.from(_vm.targets.keys()).sort(),
                            function(target) {
                              return _c(
                                "option",
                                { domProps: { value: target } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(target) +
                                      " (" +
                                      _vm._s(_vm.targets.get(target).avmDesc) +
                                      " - " +
                                      _vm._s(
                                        _vm.targets.get(target)
                                          .averageExposureSeconds
                                      ) +
                                      " sec. avg.)\n              "
                                  )
                                ]
                              )
                            }
                          )
                        ],
                        2
                      )
                    : _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.targetName,
                            expression: "targetName"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "target-name",
                          type: "text",
                          name: "name",
                          placeholder: "Target Name"
                        },
                        domProps: { value: _vm.targetName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.targetName = $event.target.value
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name"),
                          expression: "errors.has('name')"
                        }
                      ],
                      staticClass: "alert alert-danger"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("name")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Right Ascension:")]),
                  _vm._v(" "),
                  _vm.modeSelection === "list"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.raSexagesimal,
                            expression: "raSexagesimal"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          readonly: "readonly",
                          placeholder: "HH:MM:SS.S"
                        },
                        domProps: { value: _vm.raSexagesimal },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.raSexagesimal = $event.target.value
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|ra",
                            expression: "'required|ra'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.raSexagesimal,
                            expression: "raSexagesimal"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "HH:MM:SS.S",
                          name: "ra"
                        },
                        domProps: { value: _vm.raSexagesimal },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.raSexagesimal = $event.target.value
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("ra"),
                          expression: "errors.has('ra')"
                        }
                      ],
                      staticClass: "alert alert-danger"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("ra")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Declination:")]),
                  _vm._v(" "),
                  _vm.modeSelection === "list"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.decSexagesimal,
                            expression: "decSexagesimal"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          readonly: "readonly",
                          placeholder: "DD:MM:SS.S"
                        },
                        domProps: { value: _vm.decSexagesimal },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.decSexagesimal = $event.target.value
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|dec",
                            expression: "'required|dec'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.decSexagesimal,
                            expression: "decSexagesimal"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "DD:MM:SS.S",
                          name: "dec"
                        },
                        domProps: { value: _vm.decSexagesimal },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.decSexagesimal = $event.target.value
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("dec"),
                          expression: "errors.has('dec')"
                        }
                      ],
                      staticClass: "alert alert-danger"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("dec")))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "pr-2" }, [_vm._v("Filters:")]),
                    _vm._v(" "),
                    _vm._l(_vm.exposures, function(exposure) {
                      return _c(
                        "div",
                        {
                          key: exposure.filter,
                          staticClass: "form-check form-check-inline"
                        },
                        [
                          _c("input", {
                            staticClass: "form-check-input filter-check",
                            attrs: {
                              type: "checkbox",
                              value: "",
                              id: exposure.filterText + "FilterCheck",
                              "data-toggle": "collapse",
                              href: "#" + exposure.filterText + "-collapse",
                              role: "button",
                              "aria-expanded": "false",
                              "aria-controls": exposure.filterText + "-collapse"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: {
                                for: exposure.filterText + "FilterCheck"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(exposure.filterText) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "float-right",
                        attrs: {
                          href: "#",
                          onclick: "return false;",
                          tabindex: "0",
                          "data-toggle": "popover",
                          "data-trigger": "focus",
                          title: "Info",
                          "data-content": _vm.filtersHelpText
                        }
                      },
                      [_vm._v("Info")]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(_vm.exposures, function(exposure) {
                  return _c(
                    "div",
                    {
                      key: exposure.filter,
                      staticClass: "form-group collapse filter-collapse",
                      attrs: { id: exposure.filterText + "-collapse" }
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "Exposure Time (" + _vm._s(exposure.filterText) + "):"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.modeSelection === "list"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: exposure.exposureTime,
                                expression: "exposure.exposureTime"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { placeholder: "Seconds" },
                            domProps: { value: exposure.exposureTime },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  exposure,
                                  "exposureTime",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|numeric",
                                expression: "'required|numeric'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: exposure.exposureTime,
                                expression: "exposure.exposureTime"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              name: "exposureSeconds" + exposure.filter,
                              type: "number",
                              id: "exposure-time-input" + exposure.filter,
                              placeholder: "Seconds"
                            },
                            domProps: { value: exposure.exposureTime },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  exposure,
                                  "exposureTime",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has(
                                "expTime" + exposure.filter
                              ),
                              expression:
                                "errors.has('expTime' + exposure.filter)"
                            }
                          ],
                          staticClass: "alert alert-danger"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.errors.first("expTime" + exposure.filter)
                            )
                          )
                        ]
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.totalTime > 0
              ? _c("div", { staticClass: "total-time-text" }, [
                  _vm._v(
                    "\n          This observation will take about " +
                      _vm._s(_vm.totalTime) +
                      " seconds to complete.\n        "
                  )
                ])
              : _c("div", { staticClass: "total-time-text" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "exposure", mode: "out-in" } }, [
              _vm.buttonType === "go"
                ? _c(
                    "div",
                    {
                      staticClass: "tooltip-wrapper ",
                      attrs: {
                        "data-toggle": "tooltip",
                        title: _vm.buttonFeedback,
                        "data-placement": "right"
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success btn-block",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.isGoButtonDisabled ||
                              _vm.inputsAreNotAllFilledIn ||
                              !_vm.canObserve
                          },
                          on: {
                            click: function($event) {
                              return _vm.go()
                            }
                          }
                        },
                        [_vm._v("\n              Go!\n            ")]
                      )
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block ",
                      attrs: {
                        "data-toggle": "tooltip",
                        title: _vm.buttonFeedback,
                        "data-placement": "right",
                        disabled: _vm.isCancelButtonDisabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancel()
                        }
                      }
                    },
                    [_vm._v("\n            Cancel\n          ")]
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert alert-danger mt-3",
                class: { invisible: !_vm.errors.has("nonField") },
                attrs: { role: "alert" }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.errors.first("nonField")) +
                    "\n          ("
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                      onclick: "return false;",
                      tabindex: "0",
                      "data-toggle": "popover",
                      "data-trigger": "focus",
                      title: "Info",
                      "data-content": _vm.targetNotVisibleInfoText
                    }
                  },
                  [_vm._v("Info")]
                ),
                _vm._v(")\n        ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert alert-danger mt-3",
                class: { invisible: !_vm.errors.has("expTime") },
                attrs: { role: "alert" }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.errors.first("expTime")) +
                    "\n        "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-auto ml-auto" },
        [
          _c("Webcam", {
            staticClass: "pb-3",
            attrs: { telescope: _vm.telescope }
          }),
          _vm._v(" "),
          _c("image-display", {
            attrs: {
              caption: "Most recent image",
              "img-src": _vm.getThumbnail,
              "popover-content": _vm.thumbnailInfoText
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("label", { attrs: { for: "target-list" } }, [_vm._v("Target Name:")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }